'use strict';

var debug;
if (process.env.NODE_ENV !== 'production') {
    debug = require('debug')('hbnb:module:travel:selectCity');
}

var _invoke = require('../invoke');

/**
 * 选择城市
 *
 *
 * 支持版本
 * + iTrip/6.9+
 *
 *
 * @memberof travel
 * @static
 * @name selectCity
 * @param {String} city
 * @return {Promise}
 * @example
 *  hbnb.travel.selectCity('city')
 *      .then(function(city) {
 *          city = {
 *              cityName: '',
 *              cityID: ''
 *          }
 *      });
 */
module.exports = function(city) {
    if (process.env.NODE_ENV !== 'production') {
        debug('city is %s', city);
    }
    city = city || '';

    var p = new Promise(function(resolve, reject) {
        _invoke('travel', 'select_city', {
            original: city,
            callback: function(city) {
                resolve(city);
            }
        });
    });
    return p;
};



//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/~/@hfe/hbnb/travel/select-city.js
// module id = 645
// module chunks = 0